import { useCallback, useState } from 'react';
import { Outlet } from 'react-router';
import { useMediaQuery } from '../hooks/use-media-query';
import { AppSidebar } from './AppSidebar';
import { ImpersonationBanner } from './ImpersonationBanner';
import { PHONE_QUERY } from '../policies/breakpoints';
import { MobileNav } from './MobileNav';
import { MobileTopBar } from './MobileTopBar';
import { useSidebarCollapsed } from '../hooks/use-sidebar-collapsed';

/**
 * Office shell: a navigation rail on desktop and tablet, a top bar with a nav
 * drawer on phones. The yard supervisor gets YardLayout instead, not a
 * squeezed version of this.
 */
export function AppLayout() {
  const isPhone = useMediaQuery(PHONE_QUERY);
  const { collapsed, toggle } = useSidebarCollapsed();
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = useCallback(() => setNavOpen(false), []);

  return (
    <div className="flex min-h-screen bg-page">
      {!isPhone && <AppSidebar collapsed={collapsed} onToggle={toggle} />}
      <main className="min-w-0 flex-1">
        <ImpersonationBanner />
        {isPhone && (
          <>
            <MobileTopBar onOpenNav={() => setNavOpen(true)} />
            <MobileNav open={navOpen} onClose={closeNav} />
          </>
        )}
        <div className="px-4 py-6 md:px-6 md:py-8 lg:px-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
